export enum GameStatus {
    Preparing = 'Preparing',
    Waiting = 'Waiting',
    Starting = 'Starting',
    Playing = 'Playing',
    Intermission = 'Intermission',
    GameOver = 'GameOver'
}

export enum GameResult {
    Score = "Score",
    Forfeit = "Forfeit"
}

export enum GameGenre {
    Casual = "Casual",
    Wagered = "Wagered"
}

export enum Blockchain {
    Solana = "solana",
    Ethereum = "ethereum"
}

export enum HostType {
    Self = "Self",
    Redirect = "Redirect",
    Iframe = "Iframe",
    Download = "Download",
    WebGL = "WebGL"
}